<script setup lang="ts">
    import { reactive, onMounted } from 'vue';
    import { getSentIssueStatistics } from './Issues.access';
    import { type Issue } from './interfaces';
    import { timeout } from './Issues';

    const emit = defineEmits<{
        (ev: 'winnerAnnounced'): void;
    }>();

    const { issueId } = defineProps<{
        issueId: string;
    }>();

    const state = reactive<{
        issueStatistics: Issue | null;
        loading: boolean;
    }>({
        issueStatistics: null,
        loading: true,
    });

    onMounted(async () => {
        updateIssueStatistics();
    });

    const updateIssueStatistics = async () => {
        state.issueStatistics = await getSentIssueStatistics(issueId);
        state.loading = false;

        if (state.issueStatistics.IssueVariationWinner) {
            return emit('winnerAnnounced');
        }

        setTimeout(() => {
            updateIssueStatistics();
        }, timeout);
    };
</script>

<template>
    <div class="align-self-center d-flex flex-wrap gap-sm align-items-center m-xs-b">
        <div class="ug-loading-center"></div>
        {{ $Resources.IssuesWaitingForWinnerLabel }}...
    </div>
</template>
